import { __read, __spreadArray } from "tslib";
import { combineLatest } from './combineLatest';
export function combineLatestWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return combineLatest.apply(void 0, __spreadArray([], __read(otherSources), false));
}
//# sourceMappingURL=combineLatestWith.js.map